import Vue from 'vue'
import { ValidationObserver, ValidationProvider, extend, configure } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import i18n from './VueI18n'

configure({
  defaultMessage: (field, values) => {
    const newValues = values
    newValues._field_ = i18n.t(`fields.${field}`)
    return i18n.t(`validation.${newValues._rule_}`, newValues)
  }
})

Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule])
})

extend('decimal', {
  validate: (value, { decimals = 2, separator = '.' } = {}) => {
    if (value === null || value === undefined || value === '') {
      return false
    }

    const str = String(value).replace(/,/g, '')
    const regex = new RegExp(`^\\d+(\\${separator}\\d{1,${decimals}})?$`)
    return regex.test(str)
  },
  params: ['decimals'],
  message: '{_field_} must be a valid decimal with {decimals} places'
})

extend('eng-thValidator', {
  validate (value) {
    const REGEX_ENGTH = /^[A-Za-zก-๏]*$/
    return REGEX_ENGTH.test(value)
  }
})

Vue.component('validation-provider', ValidationProvider)
Vue.component('validation-observer', ValidationObserver)
